// extracted by mini-css-extract-plugin
export default {"documentContent":"LegalDocument_documentContent__1tHPi","documentFrame":"LegalDocument_documentFrame__8AC2O"};